import styled from "@emotion/styled";
import { fonts } from "styles/fonts";

export const FoodyWeekContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-family: ${fonts.rubikRegular};
  ${(props) => props.isPageError === "error" && "background-color:red;"};
`;

export const ImageHeroContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 900px;
  overflow: hidden;
  max-height: 50vh;
  margin-top: 15px;

  @media (max-width: 768px) {
    margin-top: 0px;
  }
`;

export const RecipeHeroImage = styled.img`
  max-width: 900px;
  border-radius: 8px;
  margin: 15px 0;
  max-height: 50vh;
  object-fit: cover;
  width: 100%;
  height: 550px;

  &:after {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(34, 36, 36, 0) 54.17%, rgba(34, 36, 36, 0.5) 100%);
  }

  @media (max-width: 768px) {
    border-radius: 0px;
    margin-top: 0px;
  }
`;

export const BannerImage = styled.img`
  max-width: 900px;
  border-radius: 8px;
  margin: 15px 0;
  max-height: 50vh;
  object-fit: cover;
  width: 100%;
  height: 550px;
  overflow: hidden;

  &:after {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(34, 36, 36, 0) 54.17%, rgba(34, 36, 36, 0.5) 100%);
  }
`;

export const AppStoreImage = styled.img`
  max-width: 140px !important;
  max-height: 40px !important;
  cursor: pointer;
`;

export const MobileAppImages = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0px;

  @media (max-width: 350px) {
    margin-left: 15px;
  }
`;

export const MobileAppImageBig = styled.img`
  display: block;
  position: relative;
  bottom: -30px;
  border-radius: 12px;
  z-index: 10;
  max-width: 192px !important;
  max-height: 294px !important;
`;

export const MobileAppImageSmall = styled.img`
  display: block;
  position: relative;
  bottom: -25px;
  left: -10px;
  transform: scale(0.9);
  z-index: 5;
  max-width: 146px !important;
  max-height: 269px !important;
  border-radius: 12px;
`;

export const Divider = styled.div`
  background-color: #f2f3f5;
  width: 100%;
  height: 1px;
  max-width: 800px;
  margin-bottom: 32px;
`;

export const GetAppBannerContainer = styled.div`
  position: relative;
  border-radius: 24px;
  background: #f6ece6;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 46px 54px;
  overflow: hidden;
  max-height: 280px;
  margin-bottom: 32px;
  max-width: 800px;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 490px;
    padding: 16px 24px;
  }

  h1 {
    color: #7c3200;
    font-family: ${fonts.rubikRegular};
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px; /* 100% */
  }

  p {
    color: #933a00;
    font-family: ${fonts.rubikRegular};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
    max-width: 294px;
    margin-top: 0;
    margin-bottom: 20px;
  }
`;

export const HeaderContainer = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 32px;
  max-width: 1000px;
  width: 100%;
  position: relative;
  font-family: ${fonts.rubikRegular};
  max-width: 800px;

  button {
    font-family: ${fonts.rubikRegular};
    font-size: 16px;
    font-weight: 600;
    text-decoration: underline;
    background: none;
    border: none;
  }

  @media (max-width: 768px) {
    width: 80%;
    padding: 24px 0px;
  }
`;

export const HeaderIconsContainer = styled.div`
  width: 100%;
  position: relative;
  font-family: ${fonts.rubikRegular};
  max-width: 800px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  gap: 12px;

  div {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    img {
      margin-right: 8px;
    }

    span {
      display: block;
      font-size: 14px;
      color: #111;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;

export const H1 = styled.h1`
  font-family: ${fonts.rubikRegular};
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: -0.2px;
  color: #111111;
`;
